import { getFreeRequest } from '~/services/http-requests'

const _BS_PAYMENT = 'payment'

/*
 **** GET ****
 */
function initStripeSession(orderId: IOrder['id']): Promise<any> {
    return getFreeRequest({ fullUrl: `${_BS_PAYMENT}/init_stripe_session/${orderId}/` })
}

function initAlipaySource(orderId: IOrder['id']): Promise<any> {
    return getFreeRequest({ fullUrl: `${_BS_PAYMENT}/init_alipay_source/${orderId}/` })
}

function initPayPal(orderId: IOrder['id']): Promise<any> {
    return getFreeRequest({ fullUrl: `${_BS_PAYMENT}/init_paypal/${orderId}/` })
}

function paypalCaptureOrder(orderId: IOrder['id'], approvedPayPalOrderId: string): Promise<any> {
    return getFreeRequest({ fullUrl: `${_BS_PAYMENT}/paypal_capture_order/${orderId}/${approvedPayPalOrderId}/` })
}

export { initStripeSession, initAlipaySource, initPayPal, paypalCaptureOrder }
